import React, { createContext, useContext, useState, useRef, useEffect, useMemo  } from 'react';

const ModelContext = createContext();

export const ModelProvider = ({ children }) => {
    const [userModel, setUserModel] = useState({});
    const userModelRef = useRef(userModel);
    const factory_model = useRef(null);

    useEffect(() => {
        userModelRef.current = userModel;
    }, [userModel]);

    const value = useMemo(() => ({
        userModel,
        setUserModel,
        userModelRef,
        factory_model
    }), [userModel]);

    return (
        <ModelContext.Provider value={value}>
            {children}
        </ModelContext.Provider>
    );
};

export const useModel = () => {
    return useContext(ModelContext);
};
